import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { VisualizarImagenObacPage } from './visualizar-imagen-obac.page';

const routes: Routes = [
  {
    path: '',
    component: VisualizarImagenObacPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [VisualizarImagenObacPage]
})
export class VisualizarImagenObacPageModule {}
